@if (totalElements > 0) {
  <div fxLayout="row" fxLayoutAlign="center center" class="pagination__margin-top">
    @if (currentPage !== 0) {
      <button mat-button (click)="pageLeft.emit()" data-testid="pagination-left-button">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
    }
    @if (currentPage === 0) {
      <span class="pagination__empty-nav-space"></span>
    }
    <span>
      {{getPageStart()}} - {{getPageEnd()}} of {{totalElements}}
    </span>
    @if (!isLastPage()) {
      <button mat-button (click)="pageRight.emit()" data-testid="pagination-right-button">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    }
    @if (isLastPage()) {
      <span class="pagination__empty-nav-space"></span>
    }
  </div>
}
